<template>
  <div
    class="navigation-bar"
    ref="navigationBar"
    :class="{
      '--fixed': props.fixed,
    }"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  fixed: Boolean,
})
</script>

<script>
export default {
  name: 'WidgetNavigationBar',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
